import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useRef } from 'react';

export const useOutsideClickHandler = (
  onClickOutside: (event: MouseEvent) => void,
  ref: React.RefObject<HTMLElement>,
): void => {
  const handleClick = (event: MouseEvent): void => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      onClickOutside(event);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return (): void => {
      document.removeEventListener('mousedown', handleClick);
    };
  });
};

// eslint-disable-next-line
export const useInterval = (callback: Function, delay: number | null): void => {
  // eslint-disable-next-line
  const savedCallback = useRef<Function>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    const tick = (): void => savedCallback && savedCallback.current && savedCallback.current();

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return (): void => clearInterval(id);
    }

    return (): void => { /* placeholder */ };
  }, [delay]);
};

export const useSiteMetadata = (): { apiEndpoint: string; webApp: string } => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
             apiEndpoint
             webApp
          }
        }
      }
    `,
  );

  return site.siteMetadata;
};
